import { render, staticRenderFns } from "./association.vue?vue&type=template&id=153256e2&scoped=true&"
import script from "./association.vue?vue&type=script&lang=ts&"
export * from "./association.vue?vue&type=script&lang=ts&"
import style0 from "./association.vue?vue&type=style&index=0&id=153256e2&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "153256e2",
  null
  
)

export default component.exports